import { render, staticRenderFns } from "./Denglong.vue?vue&type=template&id=55dd4215&"
import script from "./Denglong.vue?vue&type=script&lang=js&"
export * from "./Denglong.vue?vue&type=script&lang=js&"
import style0 from "./Denglong.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports